import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setPerpsUpdate } from '../ReduxSlices/TradeSlice';

export const useBlockchainStateChecker = () => {
  const dispatch = useDispatch();

  // Handle blockchain state check events
  const handleStateCheck = useCallback(() => {
    console.log('🔍 Blockchain state check triggered');
    
    // Simply trigger Redux update - this will cause TradingTable to refetch
    // and the smart detector will identify any state changes
    dispatch(setPerpsUpdate());
  }, [dispatch]);

  useEffect(() => {
    window.addEventListener('blockchainStateCheck', handleStateCheck);
    
    return () => {
      window.removeEventListener('blockchainStateCheck', handleStateCheck);
    };
  }, [handleStateCheck]);

  return null; // This hook only listens for events
};